'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { getActiveRevisionId } from 'DesignData/selectors/app';
/**
 * Denotes if the split screen editor in the Code Editor is selected.
 *
 * @returns {Boolean}
 */

export const getShowCompiledSplitScreen = state => {
  return SeamlessImmutable.getIn(state, ['codeEditor', 'options', 'showCompiledSplitScreen'], false);
};
/**
 * Denotes if the split screen editor in the Code Editor can be displayed.
 *
 * @returns {Boolean}
 */

export const getIsCompiledSplitScreenAllowed = state => {
  return !getActiveRevisionId(state);
};